import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Cookies (HttpOnly admin session) must ride along on every admin call.
const client = axios.create({ baseURL: API, withCredentials: true });

export const adminLogin = (email, password) =>
  client.post("/admin/login", { email, password }).then((r) => r.data);
export const adminSession = () => client.get("/admin/session").then((r) => r.data);
export const adminLogout = () => client.post("/admin/logout").then((r) => r.data);
export const adminPing = () => client.get("/admin/ping").then((r) => r.data);
export const adminGetSettings = () =>
  client.get("/admin/settings").then((r) => r.data);
export const adminChangePassword = (payload) =>
  client.post("/admin/change-password", payload).then((r) => r.data);
export const adminChangeEmail = (payload) =>
  client.post("/admin/change-email", payload).then((r) => r.data);
export const adminGetOrders = (params) =>
  client.get("/admin/orders", { params }).then((r) => r.data);
export const adminGetOrderDetail = (ref) =>
  client.get(`/admin/orders/${encodeURIComponent(ref)}`).then((r) => r.data);
export const adminChangeOrderStatus = (ref, newStatus) =>
  client
    .post(`/admin/orders/${encodeURIComponent(ref)}/status`, { new_status: newStatus })
    .then((r) => r.data);
